// extracted by mini-css-extract-plugin
export default {"header__logo":"HeaderLogo_header__logo__v-521","logo-img":"HeaderLogo_logo-img__pKSAO"};